import { useBusinessSettingsContext } from '../../hooks/useBusinessSettingsContext'
import Products from '../Products'
import FashionOffers from '../../storefronts/indumentaria-femenina/FashionOffers'

function PublicOffers() {
  const { activeProfile, loading } = useBusinessSettingsContext()

  if (loading && !activeProfile) {
    return null
  }

  if (activeProfile?.rubro === 'indumentaria' && (activeProfile?.subrubro || 'femenina') === 'femenina') {
    return <FashionOffers />
  }

  return <Products />
}

export default PublicOffers
